<div class="backdrop">
  <div class="spinner">
    <mat-spinner></mat-spinner>
    <div class="caption-loader">
      {{caption || 'Cargando...'}}
    </div>
  </div>
</div>

